import { render, staticRenderFns } from "./floating-footer.vue?vue&type=template&id=a02da466&scoped=true&"
import script from "./floating-footer.vue?vue&type=script&lang=ts&"
export * from "./floating-footer.vue?vue&type=script&lang=ts&"
import style0 from "./floating-footer.vue?vue&type=style&index=0&id=a02da466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02da466",
  null
  
)

export default component.exports